import React, { useState } from 'react';
import { Box, Fab, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface InsertDividerProps {
  beforeMessageId: number;
  afterMessageId: number;
  onInsert: (beforeId: number, afterId: number) => void;
}

const InsertDivider: React.FC<InsertDividerProps> = ({
  beforeMessageId,
  afterMessageId,
  onInsert,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  const handleInsertClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onInsert(beforeMessageId, afterMessageId);
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: -8,
        bottom: 0,
        width: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Vertical line */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          bottom: '10%',
          width: isHovered ? '3px' : '1px',
          backgroundColor: isHovered ? theme.palette.primary.main : theme.palette.divider,
          borderRadius: '2px',
          transition: 'all 0.2s ease',
          opacity: isHovered ? 0.8 : 0.3,
        }}
      />

      {/* Add button on hover */}
      {isHovered && (
        <Fab
          size="small"
          color="primary"
          aria-label="add entry"
          onClick={handleInsertClick}
          sx={{
            zIndex: 10,
            width: 28,
            height: 28,
            minHeight: 28,
            animation: 'fadeIn 0.2s ease',
            '@keyframes fadeIn': {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        >
          <AddIcon sx={{ fontSize: 16 }} />
        </Fab>
      )}
    </Box>
  );
};

export default InsertDivider;
